import React from 'react';
import { Heading } from '@chargify/custom-ui-components';
import { Icon } from '@chargify/icons';
import { Wrapper } from './Status.styles';

type Props = {
  text: string;
};
export const Status = ({ text }: Props) => {
  return (
    <Wrapper>
      <Icon fill={'success.main'} type={'circleCheck'} size={16} />
      <Heading variant={'h5'} color={'success.main'}>
        {text}
      </Heading>
    </Wrapper>
  );
};
